// import React, { useEffect, useState } from 'react';
// import { Card, CardHeader, Heading, CardBody, Flex, Box, useColorMode, Button, useColorModeValue, Td, Tr, Tbody, Table, Thead, Th, Text, useDisclosure, FormLabel, Input, HStack, FormControl } from '@chakra-ui/react';
// import ReactApexChart from 'react-apexcharts';
// import { useDispatch, useSelector } from 'react-redux';
// import { useUser } from 'contexts/UserContext';
// import { getCashItcLedger } from '../../../../redux/actions/dashboard';
// import { getGstAuth } from '../../../../redux/actions/settings';
// import CompanySettingForm from 'views/admin/companyProfile/CompanySettingForm';
// import { toast } from 'react-toastify';

// const ItcLedger = ({ title = 'Sales vs Purchase', height = 400, minHeight = 400 }) => {
//    const getInitialDateRange = () => {
//       const fyStartDate = localStorage.getItem('selectedFy_start_date');
//       const fyEndDate = localStorage.getItem('selectedFy_end_date');

//       const formatDate = (dateStr) => {
//          if (!dateStr) return null;
//          const parts = dateStr.split('/');
//          if (parts.length === 3) {
//             return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
//          }
//          return null;
//       };

//       const fromDate = formatDate(fyStartDate) || '2025-04-01';
//       const toDate = formatDate(fyEndDate) || '2026-03-31';

//       return { fromDate, toDate };
//    };

//    const comapnySetting = useSelector((state) => state?.company?.single);

//    const {
//       isOpen: isOpenCompanySetting,
//       onOpen: onOpenCompanySetting,
//       onClose: onCloseCompanySetting,
//    } = useDisclosure();

//    const [data, setData] = useState();
//    const [settingData, setSettingData] = useState(null);
//    const [otpValue, setOtpValue] = useState("");
//    const [otpShow, setOtpShow] = useState(false);
//    const initialDateRange = getInitialDateRange();
//    const { colorMode } = useColorMode();
//    const { user } = useUser();
//    const dispatch = useDispatch();
//    const textColor = useColorModeValue('gray.800', 'white');
//    const [gstInfo, setGstInfo] = useState(initialDateRange);

//    const handleItcLedger = async () => {
//       const today = new Date();
//       const mm = String(today.getMonth() + 1).padStart(2, "0"); // months are 0-based
//       const yyyy = today.getFullYear();
//       const returnPeriod = `${mm}${yyyy}`; // mmyyyy

//       const res = await dispatch(getCashItcLedger({
//          companyId: user?.loginhistory?.companyId,
//          returnPeriod: returnPeriod,
//       }));

//       console.log("respon", res);
//       if (res?.data?.gstData) {
//          setData(res.data);
//       }

//       if (res && res?.data?.data?.code === 'EDIT_COMPANY') {
//          // onOpenCompanyModal();
//          console.log("EDIT_COMPANY :- ", res?.data?.data?.code);
//       }
//       if (res && res?.data?.data?.code === 'EDIT_COMPANY_SETTING') {
//          setTimeout(() => {
//             toast.warn(res?.data?.message);
//          }, 1000);
//          setSettingData(comapnySetting);
//          onOpenCompanySetting();
//          console.log("companySetting", comapnySetting);
//       }
//       if (res && res?.data?.data?.code === 'GST_OTP') {
//          setTimeout(() => {
//             toast.warn(res?.data?.message);
//          }, 1000);
//          handleSendOtp();
//          // await dispatch(getGstAuth({ companyId: user?.loginhistory?.companyId }));
//          // setOtpShow(true);
//          // setIsSendOtp(true);
//          // onOpenModal();
//          console.log("GST_OTP :- ", res?.data?.data?.code);
//       }
//    };

//    const handleOtpVerify = async () => {
//       const res = await dispatch(getGstAuth({ companyId: user?.loginhistory?.companyId, otp: otpValue }));
//       console.log("Verify otp", res, otpValue);
//       if (res && res?.code === 1) {
//          setOtpShow(false);
//          setOtpValue("");
//          handleItcLedger();
//       }
//    };

//    const handleOtpCancel = async () => {
//       setOtpShow(false);
//       setOtpValue("");
//    };

//    const handleSendOtp = async () => {
//       const res = await dispatch(getGstAuth({ companyId: user?.loginhistory?.companyId }));
//       if (res && res?.code === 1) {
//          console.log("sendotp", res);
//          setOtpShow(true);
//       }
//    };

//    useEffect(() => {
//       if (!data?.gstData && !data?.lastUpdate) {
//          if (comapnySetting && comapnySetting?.setting && comapnySetting?.setting?.gstLastData) {
//             console.log("comapnySetting gstLastData", comapnySetting?.setting?.gstLastData);
//             setData(comapnySetting?.setting?.gstLastData);
//          }
//       }
//    }, [comapnySetting]);

//    console.log("ItcLedger data", data);

//    return (
//       <Card h="auto" minH={minHeight} bg={colorMode === 'dark' ? 'gray.700' : 'white'}>
//          <CardHeader>
//             <Heading size="md">
//                <Flex justifyContent="space-between">
//                   <Flex direction="column" alignItems="start" justifyContent="center">
//                      <Box color={textColor}>{title}</Box>
//                      {/* <Box fontWeight="normal" fontSize="18px" color={colorMode === 'dark' ? 'gray.300' : 'gray.600'}>
//                         ₹ {totalAmount.toLocaleString('en-IN')}
//                      </Box> */}
//                   </Flex>
//                   <Flex direction="column" alignItems="start" justifyContent="center">
//                      <Button
//                         size="sm"
//                         colorScheme="teal"
//                         onClick={handleItcLedger}
//                      >
//                         {data?.gstData && data?.lastUpdate ? "Reload Data" : "Show Data"}
//                      </Button>
//                   </Flex>
//                </Flex>
//             </Heading>
//          </CardHeader>
//          <CardBody>
//             {otpShow ? (
//                <Box>
//                   <FormControl mb={4}>
//                      <FormLabel>Enter OTP</FormLabel>
//                      <Flex gap={2}>
//                         <Input
//                            value={otpValue}
//                            placeholder="Enter 6-digit OTP"
//                            maxLength={6}
//                            type="text"
//                            size="md"
//                            onChange={(e) => setOtpValue(e.target.value)}
//                         />
//                         <Button colorScheme="green" size="sm" alignItems="center" borderRadius="10px" padding="20px" onClick={handleSendOtp}>
//                            Resend OTP
//                         </Button>
//                      </Flex>
//                   </FormControl>

//                   <HStack spacing={3} justifyContent="space-around" mt={4}>
//                      <Button colorScheme="gray" variant="outline" size="sm" borderRadius="10px" padding="20px" width="40%" onClick={handleOtpCancel}>
//                         Cancel
//                      </Button>
//                      <Button colorScheme="blue" size="sm" borderRadius="10px" padding="20px" width="40%" onClick={handleOtpVerify}>
//                         Verify
//                      </Button>
//                   </HStack>
//                </Box>
//             ) : (
//                <>
//                   <Table variant="simple" size="sm">
//                      <Thead>
//                         <Tr bg="gray.100">
//                            <Th color="gray.700" fontWeight="semibold" py={3}>
//                               Tax Type
//                            </Th>
//                            <Th color="gray.700" fontWeight="semibold" py={3}>
//                               Balance
//                            </Th>
//                         </Tr>
//                      </Thead>
//                      <Tbody>
//                         <Tr>
//                            <Td fontWeight="medium" py={2}>
//                               CGST
//                            </Td>
//                            <Td py={2}>
//                               {data?.gstData?.itc_bal?.cgst_bal !== undefined && data?.gstData?.itc_bal?.cgst_bal !== null ? `₹${parseFloat(data?.gstData?.itc_bal?.cgst_bal || 0).toFixed(2)}` : "-"}
//                            </Td>
//                         </Tr>
//                         <Tr bg="gray.50">
//                            <Td fontWeight="medium" py={2}>
//                               SGST
//                            </Td>
//                            <Td py={2}>
//                               {data?.gstData?.itc_bal?.sgst_bal !== undefined && data?.gstData?.itc_bal?.sgst_bal !== null ? `₹${parseFloat(data?.gstData?.itc_bal?.sgst_bal || 0).toFixed(2)}` : "-"}
//                            </Td>
//                         </Tr>
//                         <Tr>
//                            <Td fontWeight="medium" py={2}>
//                               IGST
//                            </Td>
//                            <Td py={2}>
//                               {data?.gstData?.itc_bal?.igst_bal !== undefined && data?.gstData?.itc_bal?.igst_bal !== null ? `₹${parseFloat(data?.gstData?.itc_bal?.igst_bal || 0).toFixed(2)}` : "-"}
//                            </Td>
//                         </Tr>
//                         <Tr>
//                            <Td fontWeight="medium" py={2}>
//                               CESS
//                            </Td>
//                            <Td py={2}>
//                               {data?.gstData?.itc_bal?.cess_bal !== undefined && data?.gstData?.itc_bal?.cess_bal !== null ? `₹${parseFloat(data?.gstData?.itc_bal?.cess_bal || 0).toFixed(2)}` : "-"}
//                            </Td>
//                         </Tr>
//                         <Tr bg="blue.50" borderTop="2px solid" borderColor="blue.200">
//                            <Td fontWeight="bold" py={3} color="blue.800">
//                               Total
//                            </Td>
//                            <Td fontWeight="bold" py={3} color="blue.800" fontSize="md">
//                               ₹{(
//                                  (parseFloat(data?.gstData?.itc_bal?.sgst_bal || 0)) +
//                                  (parseFloat(data?.gstData?.itc_bal?.cgst_bal || 0)) +
//                                  (parseFloat(data?.gstData?.itc_bal?.cess_bal || 0)) +
//                                  (parseFloat(data?.gstData?.itc_bal?.igst_bal || 0))
//                               ).toFixed(2)}
//                            </Td>
//                         </Tr>
//                      </Tbody>
//                   </Table>
//                   {/* GST Return Filing Information */}
//                   <Box mt={4} p={3} bg="gray.50" borderRadius="md" fontSize="sm" color="gray.600">
//                      {data?.lastUpdate?.ret_prd && data?.lastUpdate?.dof && (() => {
//                         const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

//                         // Format return period (mmyyyy → "Aug 2025")
//                         const ret_prd = data.lastUpdate.ret_prd; // e.g., "082025"
//                         const month = monthNames[Number(ret_prd.slice(0, 2)) - 1];
//                         const year = ret_prd.slice(2);
//                         const formattedRetPrd = `${month} ${year}`;

//                         // Format DOF (dd-mm-yyyy → "19 Sep 2025")
//                         const dof = data.lastUpdate.dof; // e.g., "19-09-2025"
//                         const [day, mon, yearDof] = dof.split("-");
//                         const formattedDof = `${day} ${monthNames[Number(mon) - 1]} ${yearDof}`;

//                         return (
//                            <Text>
//                               As per records, the GST return for{" "}
//                               <Text as="span" fontWeight="bold" color="blue.600">
//                                  {formattedRetPrd}
//                               </Text>{" "}
//                               was most recently filed on{" "}
//                               <Text as="span" fontWeight="bold" color="blue.600">
//                                  {formattedDof}
//                               </Text>
//                               .
//                            </Text>
//                         );
//                      })()}
//                   </Box>
//                </>
//             )}
//          </CardBody>
//          <CompanySettingForm
//             isOpen={isOpenCompanySetting}
//             onClose={onCloseCompanySetting}
//             isEditMode={true}
//             currentRow={settingData}
//          />
//       </Card>
//    );
// };

// export default ItcLedger;

import React, { useEffect, useRef, useState } from 'react';
import { useColorMode, useDisclosure } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getBalance, getCashItcLedger } from '../../../../redux/actions/dashboard';
import { getGstAuth } from '../../../../redux/actions/settings';
import { useUser } from 'contexts';
import { toast } from 'react-toastify';

const ItcLedger = ({ title = 'ITC Ledger Balance', height = 400, minHeight = 400 }) => {
   const getInitialDateRange = () => {
      const fyStartDate = localStorage.getItem('selectedFy_start_date');
      const fyEndDate = localStorage.getItem('selectedFy_end_date');

      const formatDate = (dateStr) => {
         if (!dateStr) return null;
         const parts = dateStr.split('/');
         if (parts.length === 3) {
            return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
         }
         return null;
      };

      const fromDate = formatDate(fyStartDate) || '2025-04-01';
      const toDate = formatDate(fyEndDate) || '2026-03-31';

      return { fromDate, toDate };
   };

   const [data, setData] = useState(null);

   const dispatch = useDispatch();
   const { user } = useUser();
   const {
      isOpen: isOpenCompanySetting,
      onOpen: onOpenCompanySetting,
      onClose: onCloseCompanySetting,
   } = useDisclosure();
   const [settingData, setSettingData] = useState(null);
   const [otpStep, setOtpStep] = useState(false);
   const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
   const inputsRef = useRef([]);
   const [otpShow, setOtpShow] = useState(false);
   const initialDateRange = getInitialDateRange();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [gstInfo, setGstInfo] = useState(initialDateRange);

   const companyList = useSelector((state) => state.company.list);
   const comapnySetting = companyList.find((comp) => comp.id === user?.loginhistory?.companyId);
   const BalanceData = useSelector((state) => state?.dashboard?.balanceData);

   useEffect(() => {
      if (user?.loginhistory?.companyId) {
         dispatch(getBalance({ CompanyId: user?.loginhistory?.companyId }));
      }
   }, [dispatch, user?.loginhistory?.companyId]);

   const handleItcLedger = async () => {
      const today = new Date();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const yyyy = today.getFullYear();
      const returnPeriod = `${mm}${yyyy}`;

      const res = await dispatch(
         getCashItcLedger({
            companyId: user?.loginhistory?.companyId,
            returnPeriod: returnPeriod,
         }),
      );

      if (res?.data?.gstData) {
         setData(res.data);
      }

      if (res && res?.data?.data?.code === 'EDIT_COMPANY') {
         console.log('EDIT_COMPANY :- ', res?.data?.data?.code);
      }
      if (res && res?.data?.data?.code === 'EDIT_COMPANY_SETTING') {
         setTimeout(() => {
            toast.warn(res?.data?.message);
         }, 1000);
         setSettingData(comapnySetting);
         onOpenCompanySetting();
         console.log('companySetting', comapnySetting);
      }
      if (res && res?.data?.data?.code === 'GST_OTP') {
         setTimeout(() => {
            toast.warn(res?.data?.message);
         }, 1000);
         setOtpShow(true);
         console.log('GST_OTP :- ', res?.data?.data?.code);
      }
   };

   const handleOtpVerify = async () => {
      const res = await dispatch(
         getGstAuth({ companyId: user?.loginhistory?.companyId, otp: Number(otpValue.join('')) }),
      );
      console.log('Verify otp', res, otpValue);
      if (res && res?.code === 1) {
         setOtpShow(false);
         setOtpValue('');
         handleItcLedger();
      }
   };

   const handleOtpCancel = async () => {
      setOtpShow(false);
      setOtpValue('');
   };

   const handleSendOtp = async () => {
      const res = await dispatch(getGstAuth({ companyId: user?.loginhistory?.companyId }));
      if (res && res?.code === 1) {
         console.log('sendotp', res);
         setOtpShow(true);
      }
   };

   useEffect(() => {
      if (!data?.gstData && !data?.lastUpdate) {
         if (comapnySetting && comapnySetting?.setting && comapnySetting?.setting?.gstLastData) {
            console.log('comapnySetting gstLastData', comapnySetting?.setting?.gstLastData);
            setData(comapnySetting?.setting?.gstLastData);
         }
      }
   }, [comapnySetting]);

   // Get tax items from BalanceData.rows if available, otherwise use gstData
   const taxItems =
      BalanceData?.rows && BalanceData.rows.length > 0
         ? BalanceData.rows.map((row) => ({
              label: row.description,
              value: row.itc_credit || 0,
              taxLiable: row.tax_liable || 0,
              gstPayable: row.gst_payable || 0,
              excessItc: row.excess_itc_credit || 0,
              creditAdjustment: row.credit_adjustment || 0,
              balanceCff: row.balance_cff_credit || 0,
              netGstPayable: row.net_gst_payable || 0,
           }))
         : [
              { label: 'CGST', value: data?.gstData?.itc_bal?.cgst_bal ?? 0 },
              { label: 'SGST', value: data?.gstData?.itc_bal?.sgst_bal ?? 0 },
              { label: 'IGST', value: data?.gstData?.itc_bal?.igst_bal ?? 0 },
              { label: 'CESS', value: data?.gstData?.itc_bal?.cess_bal ?? 0 },
           ];

   // Calculate total from BalanceData if available
   const totalBalance =
      BalanceData?.rows && BalanceData.rows.length > 0
         ? BalanceData.rows.reduce((sum, row) => sum + parseFloat(row.itc_credit || 0), 0).toFixed(2)
         : (
              parseFloat(data?.gstData?.itc_bal?.sgst_bal || 0) +
              parseFloat(data?.gstData?.itc_bal?.cgst_bal || 0) +
              parseFloat(data?.gstData?.itc_bal?.cess_bal || 0) +
              parseFloat(data?.gstData?.itc_bal?.igst_bal || 0)
           ).toFixed(2);

   const formatTableNumber = (value) => {
      const num = parseFloat(value || 0).toFixed(2);
      const [integerPart, decimalPart] = num.split('.');

      return (
         <>
            {integerPart}
            <span style={{ fontSize: '0.75em' }}>.{decimalPart}</span>
         </>
      );
   };

   return (
      <div
         className={`rounded-lg shadow-md ${
            isDark ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'
         }`}
         style={{ minHeight: `${minHeight}px` }}>
         {/* Header */}
         <div
            className={`px-6 py-4 border-b rounded-t-lg  ${
               isDark ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'
            }`}>
            <div className="flex justify-between items-center">
               <div>
                  <h2 className={`text-xl font-semibold ${isDark ? 'text-white' : 'text-gray-800'}`}>{title}</h2>
               </div>
               <button
                  onClick={handleItcLedger}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                     isDark ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-blue-600 text-white hover:bg-blue-700'
                  }`}>
                  {data?.gstData && data?.lastUpdate ? 'Reload Data' : 'Show Data'}
               </button>
            </div>
         </div>

         <div className="p-6">
            {otpShow ? (
               <div
                  className={`rounded-lg p-6 ${
                     isDark ? 'bg-gray-700 border border-gray-600' : 'bg-gray-50 border border-gray-200'
                  }`}>
                  {/* STEP 1 → Show only Send OTP */}
                  {!otpStep && (
                     <div className="flex gap-3 w-full">
                        {/* Cancel Button */}
                        <button
                           onClick={() => {
                              setOtpStep(false);
                              setOtpShow(false);
                              setOtpValue(['', '', '', '', '', '']);
                           }}
                           className={`flex-1 px-4 py-3 rounded-md font-medium flex items-center justify-center gap-2 border 
                              ${
                                 isDark
                                    ? 'border-gray-600 text-gray-300 hover:bg-gray-600'
                                    : 'border-gray-300 text-gray-700 hover:bg-gray-100'
                              }`}>
                           Cancel
                        </button>

                        {/* Send OTP Button */}
                        <button
                           onClick={() => {
                              handleSendOtp();
                              setOtpStep(true);
                           }}
                           className="flex-1 px-4 py-3 rounded-md font-medium bg-green-600 text-white hover:bg-green-700 flex items-center justify-center gap-2">
                           Send OTP
                        </button>
                     </div>
                  )}

                  {/* STEP 2 → Show OTP Input / Verify / Cancel */}
                  {otpStep && (
                     <div>
                        <label
                           className={`block text-sm font-medium mb-2 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                           Enter OTP
                        </label>

                        {/* OTP 4 Boxes */}
                        {/* <div className="flex gap-3">
                           {otpValue.map((digit, index) => (
                              <input
                                 key={index}
                                 ref={(el) => (inputsRef.current[index] = el)}
                                 type="text"
                                 maxLength={1}
                                 value={digit}
                                 onChange={(e) => {
                                    const val = e.target.value.replace(/\D/, "");
                                    const newOtp = [...otpValue];
                                    newOtp[index] = val;
                                    setOtpValue(newOtp);

                                    // Auto move next
                                    if (val && index < 5) {
                                       inputsRef.current[index + 1].focus();
                                    }
                                 }}
                                 onKeyDown={(e) => {
                                    if (e.key === "Backspace" && !otpValue[index] && index > 0) {
                                       inputsRef.current[index - 1].focus();
                                    }
                                 }}
                                 className={`w-14 h-14 text-center text-xl rounded-lg border font-semibold ${isDark
                                    ? "bg-gray-800 border-gray-600 text-white"
                                    : "bg-white border-gray-300 text-gray-900"
                                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                              />
                           ))}
                        </div> */}

                        <div className="flex items-center justify-between w-full">
                           <div className="flex gap-5">
                              {otpValue.map((digit, index) => (
                                 <input
                                    key={index}
                                    ref={(el) => (inputsRef.current[index] = el)}
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => {
                                       const val = e.target.value.replace(/\D/, '');
                                       const newOtp = [...otpValue];
                                       newOtp[index] = val;
                                       setOtpValue(newOtp);

                                       if (val && index < 5) {
                                          inputsRef.current[index + 1].focus();
                                       }
                                    }}
                                    onPaste={(e) => {
                                       e.preventDefault();
                                       const pasted = e.clipboardData.getData('text').replace(/\D/g, '');

                                       const otpArray = [...otpValue];

                                       for (let i = 0; i < 6; i++) {
                                          otpArray[i] = pasted[i] || '';
                                       }

                                       setOtpValue(otpArray);

                                       const nextIndex = Math.min(pasted.length - 1, 5);
                                       inputsRef.current[nextIndex].focus();
                                    }}
                                    onKeyDown={(e) => {
                                       if (e.key === 'Backspace' && !otpValue[index] && index > 0) {
                                          inputsRef.current[index - 1].focus();
                                       }
                                    }}
                                    className={`w-14 h-14 text-center text-xl rounded-lg border font-semibold ${
                                       isDark
                                          ? 'bg-gray-800 border-gray-600 text-white'
                                          : 'bg-white border-gray-300 text-gray-900'
                                    } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                 />
                              ))}
                           </div>
                           <button
                              onClick={handleSendOtp}
                              className={`px-4 py-2 rounded-md font-medium border ${
                                 isDark
                                    ? 'border-gray-600 text-blue-400 hover:bg-gray-700'
                                    : 'border-gray-300 text-blue-600 hover:bg-blue-50'
                              }`}>
                              🔄 Resend OTP
                           </button>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                           <button
                              onClick={() => {
                                 setOtpStep(false);
                                 setOtpShow(false);
                                 setOtpValue(['', '', '', '', '', '']);
                              }}
                              className={`flex-1 px-4 py-2 rounded-md font-medium border flex items-center justify-center gap-2 ${
                                 isDark
                                    ? 'border-gray-600 text-gray-300 hover:bg-gray-600'
                                    : 'border-gray-300 text-gray-700 hover:bg-gray-100'
                              }`}>
                              Cancel
                           </button>

                           <button
                              onClick={() => handleOtpVerify(otpValue.join(''))}
                              className="flex-1 px-4 py-2 rounded-md font-medium bg-blue-600 text-white hover:bg-blue-700 flex items-center justify-center gap-2">
                              ✔ Verify
                           </button>
                        </div>

                        {/* Resend Button */}
                        {/* <button
                           onClick={handleSendOtp}
                           className="w-full mt-3 text-sm text-blue-500 hover:text-blue-600 flex items-center justify-center gap-1"
                        >
                           🔄 Resend OTP
                        </button> */}
                     </div>
                  )}
               </div>
            ) : (
               <>
                  {/* Table */}
                  <div
                     className={`rounded-lg overflow-hidden border ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
                     <div className="overflow-x-auto">
                        <table className="w-full">
                           <thead>
                              <tr
                                 className={
                                    isDark
                                       ? 'bg-gray-700 border-b border-gray-600'
                                       : 'bg-gray-100 border-b border-gray-200'
                                 }>
                                 <th
                                    className={`px-4 py-3 text-left text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Description
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Tax Liable
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    ITC Credit
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    GST Payable
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Excess ITC Credit
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Credit Adjustment
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Net GST Payable
                                 </th>
                                 <th
                                    className={`px-4 py-3 text-right text-sm font-semibold ${
                                       isDark ? 'text-gray-200' : 'text-gray-700'
                                    }`}>
                                    Balance C/F Credit
                                 </th>
                              </tr>
                           </thead>
                           <tbody>
                              {taxItems.map((item, index) => (
                                 <tr
                                    key={item.label}
                                    className={`border-b ${
                                       isDark
                                          ? index % 2 === 0
                                             ? 'bg-gray-800 border-gray-700'
                                             : 'bg-gray-750 border-gray-700'
                                          : index % 2 === 0
                                          ? 'bg-white border-gray-200'
                                          : 'bg-gray-50 border-gray-200'
                                    }`}>
                                    <td
                                       className={`px-4 py-3 font-medium ${
                                          isDark ? 'text-gray-200' : 'text-gray-800'
                                       }`}>
                                       {item.label}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right ${isDark ? 'text-gray-300' : 'text-gray-900'}`}>
                                       {formatTableNumber(item.taxLiable)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right ${isDark ? 'text-gray-300' : 'text-gray-900'}`}>
                                       {formatTableNumber(item.value)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right ${isDark ? 'text-gray-300' : 'text-gray-900'}`}>
                                       {formatTableNumber(item.gstPayable)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right ${isDark ? 'text-gray-300' : 'text-gray-900'}`}>
                                       {formatTableNumber(item.excessItc)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right ${isDark ? 'text-gray-300' : 'text-gray-900'}`}>
                                       {formatTableNumber(item.creditAdjustment)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right font-semibold ${
                                          isDark ? 'text-red-400' : 'text-red-600'
                                       }`}>
                                       {formatTableNumber(item.netGstPayable)}
                                    </td>
                                    <td
                                       className={`px-4 py-3 text-right font-semibold ${
                                          isDark ? 'text-green-400' : 'text-green-600'
                                       }`}>
                                       {formatTableNumber(item.balanceCff)}
                                    </td>
                                 </tr>
                              ))}

                              {/* Total Row */}
                              <tr
                                 className={
                                    isDark
                                       ? 'bg-blue-900 border-t-2 border-blue-700'
                                       : 'bg-blue-50 border-t-2 border-blue-200'
                                 }>
                                 <td className={`px-4 py-4 font-bold ${isDark ? 'text-blue-200' : 'text-blue-800'}`}>
                                    TOTAL
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-blue-200' : 'text-blue-800'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.tax_liable || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-blue-200' : 'text-blue-800'
                                    }`}>
                                    {formatTableNumber(totalBalance)}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-blue-200' : 'text-blue-800'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.gst_payable || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-blue-200' : 'text-blue-800'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.excess_itc_credit || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-blue-200' : 'text-blue-800'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.credit_adjustment || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-red-400' : 'text-red-600'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.net_gst_payable || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                                 <td
                                    className={`px-4 py-4 text-right font-bold ${
                                       isDark ? 'text-green-400' : 'text-green-600'
                                    }`}>
                                    {formatTableNumber(
                                       BalanceData?.rows
                                          ? BalanceData.rows.reduce(
                                               (sum, row) => sum + parseFloat(row.balance_cff_credit || 0),
                                               0,
                                            )
                                          : 0,
                                    )}
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  {/* GST Filing Information */}
                  {data?.lastUpdate?.ret_prd &&
                     data?.lastUpdate?.dof &&
                     (() => {
                        const monthNames = [
                           'Jan',
                           'Feb',
                           'Mar',
                           'Apr',
                           'May',
                           'Jun',
                           'Jul',
                           'Aug',
                           'Sep',
                           'Oct',
                           'Nov',
                           'Dec',
                        ];
                        const ret_prd = data.lastUpdate.ret_prd;
                        const month = monthNames[Number(ret_prd.slice(0, 2)) - 1];
                        const year = ret_prd.slice(2);
                        const formattedRetPrd = `${month} ${year}`;
                        const dof = data.lastUpdate.dof;
                        const [day, mon, yearDof] = dof.split('-');
                        const formattedDof = `${day} ${monthNames[Number(mon) - 1]} ${yearDof}`;

                        return (
                           <div
                              className={`mt-4 rounded-lg p-4 text-sm ${
                                 isDark
                                    ? 'bg-gray-700 border border-gray-600 text-gray-300'
                                    : 'bg-gray-50 border border-gray-200 text-gray-600'
                              }`}>
                              As per records, the GST return for{' '}
                              <span className={`font-semibold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                                 {formattedRetPrd}
                              </span>{' '}
                              was most recently filed on{' '}
                              <span className={`font-semibold ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
                                 {formattedDof}
                              </span>
                              .
                           </div>
                        );
                     })()}
               </>
            )}
         </div>
      </div>
   );
};

export default ItcLedger;
